import GetQuoteForm from "../form/GetQuoteForm";

const MobileQuoteSection = () => (
    <div className="d-block d-md-none my-3">
      <div className="request_quote mb-4 position-relative galssset">
        <button
          className="intested_btn interestBtn"
          style={{
            backgroundColor: "var(--background-primary)",
            cursor: "default",
          }}
        >
          Request Quote
        </button>
        <div className="interst_wrapper p-0 bg-white">
          <div className="users_profile d-flex gap-3 align-items-center flex-wrap">
            <GetQuoteForm />
          </div>
        </div>
        <div className="qoute_write">
          <h5 className="mb-0">comming soon</h5>
        </div>
      </div>
    </div>
  );
  
  export default MobileQuoteSection;
  